import { WsCore } from './ws.core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';
import { api2 } from './api2';
import {
     ISchedulerBrowseFilters,
     IWsPlanningBrowsePlanningItemRes,
     IWsPlanningUserBooking,
} from './ws.typings';
import { ITask } from '../../components/planning/planning.component';

export class WsPlanning extends WsCore {
     constructor(http: HttpClient, session: SessionService) {
          super(http, session);
     }

     book(id, places?) {
          return (this.http
               .post(
                    api2() + '/api/planning/book',
                    {
                         id,
                         places: places || 1,
                    },
                    this._commonOptions({})
               )
               .toPromise()) as Promise<any>;
     }

     browsePlanning<T>(
          filters: ISchedulerBrowseFilters
     ): Promise<any | T | IWsPlanningBrowsePlanningItemRes[]> {
          return (this.http
               .get(
                    api2() + '/api/planning/browse',
                    this._commonOptions({
                         params: filters,
                    })
               )
               .toPromise()) as Promise<any>;
     }

     groupList(filters: { idCenter: number; onlyActive: boolean }) {
          return (this.http
               .get(
                    api2() + '/api/planning/groups',
                    this._commonOptions({
                         params: filters || {},
                    })
               )
               .toPromise()) as Promise<any>;
     }

     taskList(filters: { idCenter: number }): Promise<ITask[]> {
          return (this.http
               .get(
                    api2() + '/api/planning/activities',
                    this._commonOptions({
                         params: filters || {},
                    })
               )
               .toPromise()) as Promise<any>;
     }

     coachesList(filters: { idCenter: number }) {
          return (this.http
               .get(
                    api2() +
                         '/api/planning/coaches?idCenter=' +
                         (filters?.idCenter || ''),
                    this._commonOptions({})
               )
               .toPromise()) as Promise<any>;
     }

     userBookingList(): Promise<IWsPlanningUserBooking[]> {
          return (this.http
               .get(api2() + '/api/planning/book', this._commonOptions({}))
               .toPromise()) as Promise<any>;
     }

     cancelBooking(id) {
          return (this.http
               .post(
                    api2() + '/api/planning/book/cancel/' + id,
                    {},
                    this._commonOptions({})
               )
               .toPromise()) as Promise<any>;
     }

     confirmBooking(id) {
          return (this.http
               .post(
                    api2() + '/api/planning/book/cancel/' + id,
                    {},
                    this._commonOptions({})
               )
               .toPromise()) as Promise<any>;
     }
}
